/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Group_AiInputs */

const en_settings_group_ai = /** @type {(inputs: Settings_Group_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI & imports`)
};

const de_settings_group_ai = /** @type {(inputs: Settings_Group_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI & Importe`)
};

/**
* | output |
* | --- |
* | "AI & imports" |
*
* @param {Settings_Group_AiInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const settings_group_ai = /** @type {((inputs?: Settings_Group_AiInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Group_AiInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_group_ai(inputs)
	return en_settings_group_ai(inputs)
});